<template>
  <div>
    <v-card 
      class='mx-2' 
      outlined
    >
      <v-container>
        <v-row justify="center">
          <h4> User List Export to Hubspot </h4>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            PlaceId at top of hierarchy from which users will be read.
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              v-model="placeId"
              outlined
              placeholder="e.g. 0DH5Ec200Kr"
              @change="reset"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-textarea
            v-model="peopleString"
            outlined
            :label="state=='SYNC'?'Errors':'Users'"
            placeholder="App People will be shown here"
            rows="10"
          ></v-textarea>
        </v-row>
        <v-row >
          <v-btn
            color="primary darken-1" 
            class="mx-2"
            @click="getUsers"
          >
            Read Users
          </v-btn>
          <v-btn
            color="primary darken-1" 
            class="mx-2"
            :disabled="!enableSync"
            @click="postUsersToHubspot"
          >
            Sync to Hubspot
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "UserList",
  props: {
    app: Object,
    setProgressVal: Function,
    setProgressLinear: Function,
  },
  data: () => ({
    placeId: "",
    people: [],
    roleIDs: "administrator,poweruser",
    syncErrors: '',
    states: ['INIT', 'READ', 'SYNC'],
    state: 'INIT',
  }),
  computed: {
    enableSync() {
      return this.state == 'READ' && this.people?.length > 0;
    },
    peopleString() {
      if (this.state == 'READ') {
        let str = '';
        for (const person of this.people) {
          if (person?.email?.toLowerCase()?.includes('qumulex')) continue;
          const isIntegrator = !person?.place?.toHomePlaces?.customerPlace;
          const companyName = person?.place?.toHomePlaces?.customerPlace?.name ?? person?.place?.toHomePlaces?.integratorPlace?.name;
          str += `"${person.email}",`;
          str += `"${person?.lastName ?? ''}",`;
          str += `"${person?.firstName ?? ''}",`;
          str += `"${person?.roleID ?? ''}",`;
          str += `"${companyName ?? ''}",`;
          str += `"${isIntegrator ? 'Integrator' : 'End User'}"\n`
        }
        return str;
      } else if (this.state == 'SYNC') {
        return this.syncErrors;
      } else {
        return '';
      }
    }
  },
  methods: {
    reset() {
      this.state = 'INIT';
      this.people = [];
    },
    async getUsers() {
      this.state = 'READ';
      let url = '/API/public/contacts/users';
      url += "?placeID=" + this.placeId;
      url += "&roleIDs=" + encodeURIComponent(this.roleIDs);
      this.app.restApi({
          method: 'get',
          url: url,
          headers: {
            'Authorization': 'Bearer ' + this.app.userProfile.token
          }
        })
        .then(async response => {
          console.log("Success: /API/public/contacts/users");
          this.people = response.data;
        })
        .catch( error => {
          console.log(error);
          alert("Failed to get people from QxControl cloud. error=" + error?.response?.status)
          this.state = 'INIT';
        });
    },

    async postUsersToHubspot() {
      this.state = 'SYNC';
      this.setProgressVal(0);
      this.setProgressLinear(true);
      this.syncErrors = '';
      let idx = 0;
      for (const person of this.people) {
        console.log(person?.email)
        if (person?.email?.toLowerCase()?.includes('qumulex')) continue;
        let url = 'API/public/contact/new';
        const isIntegrator = !person?.place?.toHomePlaces?.customerPlace;
        const companyName = person?.place?.toHomePlaces?.customerPlace?.name ?? person?.place?.toHomePlaces?.integratorPlace?.name;
        const customerId =  isIntegrator ? person?.place?.toHomePlaces?.integratorPlace?.qxCustomerID : '';
        url += '?email=' + encodeURIComponent(person.email)
        if (companyName) url += '&companyName=' + encodeURIComponent(companyName);
        if (person?.firstName) url += '&firstName=' + encodeURIComponent(person.firstName);
        if (person?.lastName) url += '&lastName=' + encodeURIComponent(person.lastName);
        if (customerId) url += '&qxCustomerId=' + customerId;
        url += '&relationship=' + encodeURIComponent(isIntegrator ? 'Integrator' : 'End User');
        if (!isIntegrator) url += '&type=Customer';
        url += '&listName=' + encodeURIComponent('QxControl Users');

        await this.app.restApi({
            method: 'post',
            url: url,
            headers: {
              'Authorization': 'Bearer ' + this.app.userProfile.token
            },
          })
          .catch(error => {
            let str = `"${error?.response?.status}",`
            str += `"${person.email}",`;
            str += `"${person?.lastName ?? ''}",`;
            str += `"${person?.firstName ?? ''}",`;
            str += `"${companyName ?? ''}",`;
            str += `"${isIntegrator ? 'Integrator' : 'End User'}",`;
            str += `"${customerId ? customerId : ''}"\n`
            this.syncErrors += str;
          });
        idx++;
        this.setProgressVal(100*idx/this.people.length);
      }
      this.setProgressLinear(false);
    },
  }
}
</script>